export default __webpack_public_path__ + "static/media/dotsMenu.b4812643.svg";